import { useEffect } from "react";

const ORIGIN = "https://bookandsmiles.com";

const setMeta = (name, content) => {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setOg = (property, content) => {
  const el = document.head.querySelector(`meta[property="${property}"]`);
  if (el) el.setAttribute("content", content);
};

export const Seo = ({ title, description, schema, noindex = false }) => {
  useEffect(() => {
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    if (title) {
      document.title = title;
      setOg("og:title", title);
    }
    if (description) {
      setMeta("description", description);
      setOg("og:description", description);
    }
    setOg("og:url", `${ORIGIN}${window.location.pathname}`);

    let script = document.getElementById("page-jsonld");
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
    return () => {
      const s = document.getElementById("page-jsonld");
      if (s) s.remove();
    };
  }, [title, description, schema]);

  return null;
};

export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    ...(it.to ? { item: `${ORIGIN}${it.to}` } : {}),
  })),
});

export const serviceSchema = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name,
  description,
  url: `${ORIGIN}${path}`,
  provider: { "@id": `${ORIGIN}/#business` },
  areaServed: "France",
});

export default Seo;
